// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Index styles */

body {
  margin: 0;
  box-sizing: border-box;
  min-height: 100vh;
  background-color: #ebdfcc;
}

a {
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

h1,
p {
  color: #322217;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB;EACE,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;AAChB","sourcesContent":["/* Index styles */\n\nbody {\n  margin: 0;\n  box-sizing: border-box;\n  min-height: 100vh;\n  background-color: #ebdfcc;\n}\n\na {\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: underline;\n}\n\nh1,\np {\n  color: #322217;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
